import { Environment } from 'dashboard/models/environment';
import { Event, RedactedObjectPaths } from 'dashboard/models/event';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

interface EventsPayload {
  events: Event[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export interface EventsFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  omni?: string;
  names?: string[];
}

interface FiltersPayload {
  filters: EventsFilterParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

interface RedactedObjectPathsPayload {
  redactedObjectPaths: RedactedObjectPaths;
}

export type EventsActions =
  | Action<EventsActionType.SetEvents, EventsPayload>
  | Action<EventsActionType.SetFilters, FiltersPayload>
  | Action<EventsActionType.SetCurrentPage, CurrentPagePayload>
  | Action<EventsActionType.SetPageSize, PageSizePayload>
  | Action<EventsActionType.SetRedactedObjectPaths, RedactedObjectPathsPayload>;

export enum EventsActionType {
  SetEvents = 'events/SET_EVENTS',
  SetFilters = 'events/SET_FILTERS',
  SetCurrentPage = 'events/SET_CURRENT_PAGE',
  SetPageSize = 'events/SET_PAGE_SIZE',
  SetRedactedObjectPaths = 'events/SET_REDACTED_OBJECT_PATHS',
}

export function setEvents(
  events: Event[],
  environment: Environment,
  paginationParams: PaginationParams,
) {
  return {
    payload: {
      events,
      environment,
      paginationParams,
    },
    type: EventsActionType.SetEvents,
  };
}

export function setFilters(filters: EventsFilterParams) {
  return {
    payload: {
      filters,
    },
    type: EventsActionType.SetFilters,
  };
}

export function setCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: EventsActionType.SetCurrentPage,
  };
}

export function setPageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: EventsActionType.SetPageSize,
  };
}

export function setRedactedObjectPaths(redactedObjectPaths: RedactedObjectPaths) {
  return {
    payload: {
      redactedObjectPaths,
    },
    type: EventsActionType.SetRedactedObjectPaths,
  };
}
